import React, { CSSProperties, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { User } from '@/types/userList';
import { Ul, Li, A } from '@/components/pages/Users/Index/List';

type Props = {
  hasError: boolean;
  isPreview: boolean;
  onEditLinkClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    userId: number,
  ) => void;
  recomputeRowHeights: () => void;
  style: CSSProperties;
  user: User;
};

export const Item: React.FC<Props> = memo(
  ({
    hasError,
    isPreview,
    onEditLinkClick,
    recomputeRowHeights,
    style,
    user,
  }) => {
    const { t } = useTranslation();
    return (
      <Ul style={style} hasError={hasError}>
        <Li width="100">{user.lastName}</Li>
        <Li width="100" narrowMargin={true}>
          {user.firstName}
        </Li>
        <Li width="100" narrowMargin={true}>
          {user.kanaLastName}
        </Li>
        <Li width="100" narrowMargin={true}>
          {user.kanaFirstName}
        </Li>
        <Li width="200">{user.email}</Li>
        <Li width="156">{user.nameId}</Li>
        {!isPreview && (
          <Li width="24">
            <A
              onClick={(e) => {
                onEditLinkClick(e, user.id);
                recomputeRowHeights();
              }}
            >
              {t('ui.action.edit')}
            </A>
          </Li>
        )}
      </Ul>
    );
  },
);
